<template>
  <div class="knowledgeSearch">
    <div class="hotSearch">
      <div class="flexRow" v-if="logSearchList.length>0">
        <p>搜索记录：</p>
        <ul style="flex: 1;">
         <li v-for="item in logSearchList">
            <span class="hand" @click="handleSearchLog(item.keyWords)" v-html="item.keyWords"></span>
            <i v-if="item.hot" class="iconfont icon-hot"></i>
          </li>
          <li v-if="logSearchList.length==0&&hotSearchList.length==0">&nbsp;</li><!-- 防止无数据时 容器高度和有数据时不一致 -->
        </ul>
      </div>
      <div class="flexRow" v-if="hotSearchList.length>0">
        <p>热搜记录：</p>
        <ul style="flex: 1;">
          <li v-for="item in hotSearchList">
            <span class="hand" @click="handleSearchLog(item.keyWords)" v-html="item.keyWords"></span>
            <!-- <i v-if="item.hot" class="iconfont icon-hot"></i> -->
          </li>
          <li v-for="item in hotSearchList">
            <span class="hand" @click="handleSearchLog(item.keyWords)" v-html="item.keyWords"></span>
            <!-- <i v-if="item.hot" class="iconfont icon-hot"></i> -->
          </li>
          <li v-if="logSearchList.length==0&&hotSearchList.length==0">&nbsp;</li><!-- 防止无数据时 容器高度和有数据时不一致 -->
        </ul>
      </div>

    </div>
    <div class="content">
      <el-tabs v-model="editableTabsValue" @tab-click="handleTabchange">
        <el-tab-pane v-for="(item, index) in editableTabs" :key="item.id" :name="item.name">
          <span slot="label">
            <span>{{item.title}}</span>
            <span style="font-size: 14px;">({{item.total}})</span>
          </span>
        </el-tab-pane>
      </el-tabs>

      <div class="tabsContent">
        <div class="searchResultTitle flexRow flexRowBetween">
          <div class="flexRow">
            <p class="fn18">{{searchText}}</p>
            <p class="fn14" style="color: #333;">共为你搜索到</p><p class="fn15">{{total}}</p><p class="fn14" style="color: #333;">个结果</p>
          </div>
          <div class="flexRow" v-show="$store.state.userId">
            <p class="fn14 mar10" style="color: #333;">我的知识库</p>
            <el-switch v-model="switchflag" active-color="#F5726E" inactive-color="#D2D2D2" @change="handleSwitchChange">
            </el-switch>
          </div>
        </div>
        <div class="resultContent">
          <div v-for="item in searchResult" >
            <div class="resuleBox" v-if="item.goodsUserBuyRecord&&item.goodsUserBuyRecord.id"> <!-- 已购买的 -->
              <div class="time">
                <p class="fn12">{{item.onShelvesDate | timeAgoLength}}</p>
                <p class="fn12">{{item.onShelvesDate | substring(3)}}</p>
              </div>
              <div class="image hand" @click="showDetail(item.id,'3')" >
                <img v-if="item.showPicPath" v-bind:src="''+$store.state.defaultPicUrl+item.showPicPath+''" />
                <img v-else src="@/assets/images/shebei1.png" />
              </div>
              <p class="fn14 margin0 hand" @click="showDetail(item.id,'3')">{{item.name}}</p>
              <!-- <span class="typeName hand" @click="showDetail(item.id,'3')" >{{item.name}}</span>
              <p class="fn14 margin0 ">{{item.goodsCatalogueId.name}}</p> -->
              <div  class="buyIcon"><!-- 已购买图标 -->
                  <img src="@/assets/images/Purchased.png">
              </div>
            </div>

            <div class="resuleBox" v-else-if="!(item.goodsUserBuyRecord&&item.goodsUserBuyRecord.id)&&!switchflag"> <!-- 未购买的 -->
              <div class="time">
                <p class="fn12">{{item.onShelvesDate | timeAgoLength}}</p>
                <p class="fn12">{{item.onShelvesDate | substring(3)}}</p>
              </div>
              <div class="image hand" @click="showDetail(item.id,'2')" >
                <img v-if="item.showPicPath" v-bind:src="''+$store.state.defaultPicUrl+item.showPicPath+''" />
                <img v-else src="@/assets/images/shebei1.png" />
              </div>
              <p class="fn14 margin0 hand" @click="showDetail(item.id,'2')">{{item.name}}</p>
              <!-- <span class="typeName hand" @click="showDetail(item.id,'2')" >{{item.name}}</span>
              <p class="fn14 margin0 ">{{item.goodsCatalogueId.name}}</p> -->
            </div>

            <div  class="OnTrial flexRow" v-if="item.goodsUserBuyRecord&&item.goodsUserBuyRecord.id"><!-- 已购买  -->
              <div class="flex1 bgcolor1">{{ item.goodsUserBuyRecord.endUseTime  | substring(3)}}前</div>
              <div class="obliqueLine"></div>
              <div class="bgcolor">可使用<span style="font-size: 16px;">{{ item.goodsUserBuyRecord.notUsedNumber }}</span>次</div>
            </div>

            <div  class="OnTrial "  v-else-if="!(item.goodsUserBuyRecord&&item.goodsUserBuyRecord.id)&&!switchflag"><!-- 未购买 -->
              <!-- <div class="flex1 bgcolor2">&yen;{{item.goodsPriceInfo.price}} </div>
              <div class="obliqueLine1"></div>
              <div class="price">&yen;{{item.goodsPriceInfo.realPrice}}</div> -->
              <div class="flexRow" v-if="item.goodsPriceInfo.priorityLevel=='1'">
                <div class="flex1 bgcolor2">登录后使用</div>
                <div class="obliqueLine1"></div>
                <div class="price">&yen;{{item.goodsPriceInfo.price}}</div>
              </div>
              <div class="flexRow" v-else-if="item.goodsPriceInfo.priorityLevel=='10'">
                <div class="flex1 bgcolor2">完善信息后使用</div>
                <div class="obliqueLine1"></div>
                <div class="price">&yen;{{item.goodsPriceInfo.price}}</div>
              </div>
              <div class="flexRow" v-else-if="item.goodsPriceInfo.priorityLevel=='15'">
                <div class="flex1 bgcolor2">免费试用</div>
                <div class="obliqueLine1"></div>
                <div class="price">&yen;{{item.goodsPriceInfo.price}}</div>
              </div>
              <div class="flexRow" v-else-if="item.goodsPriceInfo.priorityLevel=='20'">
                <div class="flex1 bgcolor2">购买使用</div>
                <div class="obliqueLine1"></div>
                <div class="price">&yen;{{item.goodsPriceInfo.price}}</div>
              </div>
              <div class="flexRow" v-else>
                <div class="flex1 bgcolor2">&yen;{{item.goodsPriceInfo.price}} </div>
                <div class="obliqueLine1"></div>
                <div class="price">&yen;{{item.goodsPriceInfo.realPrice}}</div>
              </div>


            </div>
          </div>
        </div>
        <div class="paging">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" @prev-click="handlePrevClick"
            @next-click="handleNextClick" :current-page.sync="currentPage" :page-size="pageSize" layout="total,prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
  export default ({
    name: 'knowledgeSearch',
    data() {
      return {
        searchText: '', //查询内容
        logSearchList: [], //搜索历史记录数组
        hotSearchList: [], //热搜数组
        editableTabsValue: 'all', //默认活动标签页（all-全部）
        editableTabs: [{
          title: '全部', //标题
          name: 'all', //关键值key
          id: 'all', //关键值key
          total: '0' //数量
        }], //查询结果页签数组
        switchflag: false, //是否显示我的知识库
        searchResult: [], //查询结果列表数据
        currentPage: 1, //活动页号
        pageSize: 10, //页码大小
        total: 0, //全部/分页数据总数
        reloadSearchTitle: 'false' //是否刷新查询结果头部页签
      }
    },
    created: function() {
	  //1.加载搜索历史记录
      this.loadLogSearchList();

	  //2.加载热搜
	  this.loadHotSearchList();
    },
    methods: {
      //选择搜索记录
      handleSearchLog(val){
        this.$emit('searchInfo', {
          'reloadSearchTitle': true,
          'searchText': val
        });
      },
      //我的知识库切换
      handleSwitchChange(newVal){
        this.$emit('searchInfo', {
          'showSelf': newVal,
          'reloadSearchTitle': true
        });
      },
      handleTabchange: function(tab, event) { //切换结果页签
        let this_ = this;
        let activeName = tab.name; //获取到当前元素的name
        let params_ = {};
        if (activeName === undefined || activeName === null || activeName === '') return;
        if (activeName === 'all') {
          params_ = {
            'searchType': '',
            'reloadSearchTitle': this.reloadSearchTitle
          };
        } else {
          params_ = {
            'searchType': activeName,
            'reloadSearchTitle': this.reloadSearchTitle
          };
        }
        this_.$emit('searchInfo', params_);
      },
      //加载查询信息头
      loadSearchText: function(val) {
        this.searchText = val;
      },
      loadLogSearchList: function() {

        let this_ = this;
        let paramdata = {};
        paramdata.url = "/SJHG/logs/common/logscommon/getLogsGoodsSearchListByUserId";
        paramdata.data = {pageNo:1,pageSize:5}; //json对象
        paramdata.onSuccess = function(res) {
          if (res.data.ok&&res.data.result) {
            var list_logsGoodsSearch = res.data.result.list_logsGoodsSearch;
            let tableData = [];
            list_logsGoodsSearch.map((item, index) => {
              tableData.push({
                keyWords: item.searchContent,
                hot: false
              });
            });
            this_.logSearchList = tableData;
          } else {
            console.log(res);
          }
        };
        paramdata.onFailed = function(res) {
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);
      },
	  //加载热搜
	  loadHotSearchList: function() {
	    let this_ = this;
	    let paramdata = {};
	    paramdata.url = "/SJHG/logs/common/logscommon/getHotSearchLimit";
	    paramdata.data = {start:0,pageSize:2}; //热搜前3
	    paramdata.onSuccess = function(res) {
	      if (res.data.ok&&res.data.result) {
	        var list_hotGoodsSearch = res.data.result;
	        let tableData = [];
	        list_hotGoodsSearch.map((item, index) => {
	          tableData.push({
	            keyWords: item,
	            hot: true
	          });
	        });
	        this_.hotSearchList = tableData;
	      } else {
	        console.log(res);
	      }
	    };
	    paramdata.onFailed = function(res) {
	      console.log(res);
	    };
	    this_.$axiosUtil.postServer(paramdata);
	  },
      //加载查询商品目录分类下商品数量
      loadSearchTitleResult: function(resultList) {
        let this_ = this;
        let total = 0;
        let defaultEditableTabs = [{
          title: '全部', //标题
          name: 'all', //关键值key
          id: 'all', //关键值key
          total: total //数量
        }];

        if (!resultList || resultList.length == 0) {
          //无数据重置页签
        } else {
          resultList.map((item, index) => {
            // console.log(item.id)
            defaultEditableTabs.push({
              title: item.name,
              name: item.id,
              id: item.id,
              total: item.total
            });
            total += Number(item.total);
          });
          defaultEditableTabs[0].total = total;
        }
        this_.editableTabs = defaultEditableTabs;
        // console.log(this_.editableTabs);
        this_.editableTabsValue = defaultEditableTabs[0].name;
      },
      //加载查询结果
      loadSearchResult: function(result) {
        //重新加载搜索记录
        this.loadHotSearchList();

        let this_ = this;
        let list = [];
        let pageNo = 1;
        let pageSize = 10;
        let count = 0;

        let page_ = result.page; //全部
        //判断有无查询结果
        if (page_.count === undefined || !page_.count || page_.count === null || page_.count === 'null' || page_.count ===
          0) {

        } else {
          list = page_.list;
          pageNo = page_.pageNo;
          pageSize = page_.pageSize;
          count = page_.count;
        }
        this_.searchResult = list;
        this_.currentPage = pageNo;
        this_.pageSize = pageSize;
        this_.total = count;
      },
      handleSizeChange(val) {
        this.$emit('searchInfo', {
          'pageSize': val,
          'reloadSearchTitle': this.reloadSearchTitle
        });
      },
      handleCurrentChange(val) {
        this.$emit('searchInfo', {
          'pageNo': val,
          'reloadSearchTitle': this.reloadSearchTitle
        });
      },
      handlePrevClick(val) { //上一页
        this.$emit('searchInfo', {
          'pageNo': val,
          'reloadSearchTitle': this.reloadSearchTitle
        });
      },
      handleNextClick(val) { //下一页
        this.$emit('searchInfo', {
          'pageNo': val,
          'reloadSearchTitle': this.reloadSearchTitle
        });
      },
      showDetail(val,type){//商品详情
          if(type==='1'){
            this.$router.push({path:"/algorithmDetail",query:{"id":val}});
          }else if(type==='2'){
            this.$router.push({path:"/toolKnowledgeDetails",query:{"id":val}});
          }else if(type==='3'){
            this.$router.push({path:"/toolKnowledgeDetails",query:{"id":val,"isbuy":"yes"}});
          }

      }
    }
  })
</script>

<style lang="scss" scoped>
  .hotSearch {
    background: $color-primary;
    padding: 5px 0;
    >div{width: 640px;margin: 0 auto;}
    p{
      margin: 0;
      font-size: 14px;
      color: #fff;
    }
  }

  .hotSearch ul {
    margin: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .hotSearch ul li {
    padding: 5px 10px;
    margin-right: 10px;
    color: #fff;
    font-size: 14px;
    position: relative;
  }

  .hotSearch ul li .icon-hot {
    position: absolute;
    right: -8px;
    top: -2px;
    font-size: 20px;
    color: black;
  }

  .content {
    width: 1280px;
    margin: 0 auto;
    padding-top: 20px;
  }

  .content>>>.el-tabs__item {
    font-size: 18px;
    background: #F2F2F2;
    color: #807874;
    margin-right: 3px;
    padding: 0 20px;
  }

  .content>>>.el-tabs__item:hover {
    color: $color-primary;
  }

  .content>>>.el-tabs__active-bar {
    display: none;
  }

  .content>>>.el-tabs__nav-wrap::after {
    background: $color-primary;
    height: 1px;
    z-index: 2;
  }

  .content>>>.el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding-left: 20px;
  }

  .content>>>.el-tabs--top .el-tabs__item.is-top:last-child {
    padding-right: 20px;
  }

  .content>>>.el-tabs__item.is-active {
    color: #fff;
    background: $color-primary;
  }

  .flexRow {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .flexRowBetween {
    justify-content: space-between;
  }

  .fn18 {
    font-size: 22px;
    color: #108DE9;
    margin: 10px;
  }

  .fn14 {
    font-size: 14px;
  }

  .fn15 {
    font-size: 16px;
     color: #108DE9;
     margin: 5px;
  }

  .mar10 {
    margin-right: 10px;
  }

  .resultContent {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .resultContent>div {
    box-sizing: border-box;
    width: 20%;
    padding: 5px;
  }

  .resuleBox {
    border: 1px solid $color-primary;
    box-sizing: border-box;
    padding: 2px 5px;
    position: relative;
  }

  .fn12 {
    font-size: 12px;
    color: #666;
    text-align: right;
    margin: 0 0 4px;
  }

  .image {
    height: 150px;
  }

  .image>img {
    height: 150px;
    width: 100%;
  }

  .typeName {
    display: block;
    padding: 2px 6px;
    background: $color-primary;
    color: #fff;
    margin: 8px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .margin0 {
    margin: 0;
    color: #666;
  }

  .OnTrial {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    border: 1px solid $color-primary;
    border-top: none;
  }

  .flex1 {
    flex: 1;
  }

  .obliqueLine {
    width: 0;
    height: 0;
    border-bottom: 30px solid $color-primary;
    border-left: 15px solid #F8F8F8;
  }

  .obliqueLine1 {
    width: 0;
    height: 0;
    border-top: 30px solid $color-primary;
    border-right: 15px solid transparent;
  }

  .bgcolor {
    background: $color-primary;
    color: #fff;
    text-align: right;
  }

  .bgcolor1 {
    background: #F8F8F8;
    color: $color-primary;
  }

  .price {
    color: #999999;
    width: 82px;
    text-align: center;
    text-decoration: line-through;
  }

  .bgcolor2 {
    background: $color-primary;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
  }

  .paging {
    display: flex;
  }

  .paging>>>.el-pagination {
    display: block;
    margin: 10px auto;
  }

  .paging>>>.el-pager li.active {
    color: $color-primary;
  }

  .paging>>>.el-pager li {
    font-size: 16px;
    font-weight: normal;
    color: #666;
  }

  .hand {
    cursor: pointer;
  }
  .buyIcon{
    position: absolute;
    left: 10px;
    top:10px;
    width: 70px;
    height: 50px;
  }
  .buyIcon img{
    width:100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/knowledgeSearch.vue